export default __webpack_public_path__ + "static/media/instagram.7f1cda98.png";